export default "__VITE_ASSET__DSnkTahN__"